export default "/videos/3254d152ceb290554c297b8a85944a42.mp4";